<template>
  <div class="SubPage__container">
    <PageHeader1XP />
    <main id="main">
      <section class="SubPage__contentGrid SubPage__firstGrid">
        <Breadcrumbs />
        <div class="columns is-variable">
          <Button1XP
            class="column"
            size="s"
            start-icon="arrow_back"
            :text="backBtnLabel"
            variant="link"
            @click="handleBackClick"
          />
        </div>
        <div class="columns is-variable is-multiline">
          <div class="column is-three-quarters-desktop is-full-tablet">
            <HeaderBox
              :links="['Dokument1', 'Dokument2', 'Dokument3']"
              subtitle="Ausgewählte Dokumente"
              text="Standardausführung"
              title="Rohrfedermanometer, Kupferlegierung"
              type="Typen 111.10, 111.12"
            />
          </div>
          <div class="column is-one-quarter-desktop is-full-tablet">
            <SalesContainer :config="salesContainerConfig" />
          </div>
          <div v-if="isTabletOrMobile" class="column is-full">
            <div :class="$style.sidebarProduct">
              <SidebarSlider :slides="slides" />
              <SidebarShopTeaser />
            </div>
          </div>
        </div>
      </section>
      <section class="SubPage__contentGrid">
        <div class="columns is-variable is-multiline">
          <div class="column is-three-quarters-desktop is-full-tablet">
            <div id="detailSection" style="display: none">
              <div class="ProductDetailSection__container">
                <section :class="[$style.detailItem, 'column', 'is-two-thirds-desktop', 'is-full']">
                  <h2>Anwendungen</h2>
                  <ul>
                    <li>
                      Für Messstellen mit erhöhter Differenzdrucküberlast und/oder hohen
                      Betriebsdrücken (stat. Drücken), auch in aggressiver Umgebung
                    </li>
                    <li>
                      Für gasförmige, flüssige, verunreinigte, viskose und aggressive Messstoffe
                    </li>
                    <li>Pumpenüberwachung und -steuerung</li>
                    <li>Filterüberwachung</li>
                    <li>Füllstandsmessung an geschlossenen Behältern</li>
                  </ul>
                </section>
                <section :class="[$style.detailItem, 'column', 'is-two-thirds-desktop', 'is-full']">
                  <h2>Leistungsmerkmale</h2>
                  <ul>
                    <li>Differenzdruckmessbereiche ab 0 … 60 mbar</li>
                    <li>
                      Hoher Betriebsdruck (statischer Druck) und hohe Überlastsicherheit wahlweise
                      bis 40, 100, 250 oder 400 bar
                    </li>
                    <li>
                      Messzellenflüssigkeitsdämpfung gegen hohe Druckänderungsgeschwindigkeiten
                    </li>
                    <li>Kompatibel mit Schaltkontakten</li>
                    <li>Typ 762.14: Monelausführung</li>
                  </ul>
                </section>
                <section :class="[$style.detailItem, 'column', 'is-two-thirds-desktop', 'is-full']">
                  <h2>Beschreibung</h2>
                  <p>
                    Diese Differenzdruckmanometer zeichnen sich durch die hochkorrosionsbeständige
                    CrNi-Stahl-Ausführung aus. Die hohe Überlastbarkeit wird durch eine vollflächige
                    metallische Anlage des Plattenfeder-Messelementes erreicht.
                  </p>
                  <ul>
                    <li>Die Verwendung hochwertiger CrNi-Stahl-Werkstoffe</li>
                    <li>verfahrenstechnischen Prozessen und ist für flüssige</li>
                  </ul>
                  <p>
                    Die messstoffberührten Bauteile sind für diese Geräte auch aus Sonderwerkstoffen
                    wie Monel oder Hastelloy verfügbar.
                  </p>
                  <p>
                    Anzeigebereiche von 0 ... 60 mbar bis 0 ... 40 bar stellen die in
                    verschiedensten Applikationen geforderten Messbereiche sicher.
                  </p>
                </section>
              </div>
            </div>
            <ProductDetailTabs :config="tabsConfig" />
          </div>
          <aside
            v-if="!isTabletOrMobile"
            class="column is-one-quarter-desktop is-full-tablet SubPage__sideBar"
          >
            <div class="columns is-variable is-multiline">
              <div class="column is-full">
                <div :class="$style.sidebarProduct">
                  <SidebarSlider :slides="slides" />
                  <SidebarShopTeaser />
                </div>
              </div>
            </div>
          </aside>
        </div>
      </section>
    </main>
    <Footer1XP />
    <CookieDisclaimer :config="cookieDisclaimerConfig" />
    <ProductDetailSection />
  </div>
</template>

<script setup>
import Button1XP from '../Button1XP/Button1XP.vue';
import CookieDisclaimer from '../CookieDisclaimer/CookieDisclaimer.vue';
import Footer1XP from '../Footer1XP/Footer1XP.vue';
import HeaderBox from '../HeaderBox/HeaderBox.vue';
import SalesContainer from '../SalesContainer/SalesContainer.vue';
import SidebarSlider from '../SidebarSlider/SidebarSlider.vue';
import ProductDetailSection from '../ProductDetailSection/ProductDetailSection.vue';
import { onBeforeMount } from 'vue';
import ProductDetailTabs from '../../components/ProductDetailTabs/ProductDetailTabs.vue';
import SidebarShopTeaser from '../SidebarShopTeaser/SidebarShopTeaser.vue';
import { isTabletOrMobile } from '../../utils/breakpoints';
import Breadcrumbs from '../Breadcrumbs/Breadcrumbs.vue';
import PageHeader1XP from '../PageHeader1XP/PageHeader1XP.vue';

//setPublicPath()

const tabsConfig = [
  {
    title: 'Details',
    id: 'detailSection',
    sliders: [
      {
        title: 'Zubehör',
        products: [
          {
            image: 'https://picsum.photos/200/200?random=1',
            type: 'Typ 910.14',
            title: 'Dichtungen für Druckmessgeräte',
            text: 'Für die Prozessindustrie, hochüberlastsicher bis 40, 100, 250 oder 400 bar',
            primaryLink: '#',
          },
        ],
      },
      {
        title: 'Ähnliche Produkte2',
        products: [
          {
            image: 'https://picsum.photos/200/200?random=4',
            type: 'Typ 910.14',
            title: 'Dichtungen für Druckmessgeräte',
            text: 'Für die Prozessindustrie, hochüberlastsicher bis 40, 100, 250 oder 400 bar',
            primaryLink: '#',
          },
          {
            image: 'https://picsum.photos/200/200?random=5',
            type: 'Typ 910.14',
            title: 'Dichtungen für Druckmessgeräte',
            text: 'Für die Prozessindustrie, hochüberlastsicher bis 40, 100, 250 oder 400 bar',
            primaryLink: '#',
          },
          {
            image: 'https://picsum.photos/200/200?random=6',
            type: 'Typ 910.14',
            title: 'Dichtungen für Druckmessgeräte',
            text: 'Für die Prozessindustrie, hochüberlastsicher bis 40, 100, 250 oder 400 bar',
            primaryLink: '#',
          },
          {
            image: 'https://picsum.photos/200/200?random=4',
            type: 'Typ 910.14',
            title: 'Dichtungen für Druckmessgeräte',
            text: 'Für die Prozessindustrie, hochüberlastsicher bis 40, 100, 250 oder 400 bar',
            primaryLink: '#',
          },
          {
            image: 'https://picsum.photos/200/200?random=5',
            type: 'Typ 910.14',
            title: 'Dichtungen für Druckmessgeräte',
            text: 'Für die Prozessindustrie, hochüberlastsicher bis 40, 100, 250 oder 400 bar',
            primaryLink: '#',
          },
          {
            image: 'https://picsum.photos/200/200?random=6',
            type: 'Typ 910.14',
            title: 'Dichtungen für Druckmessgeräte',
            text: 'Für die Prozessindustrie',
            primaryLink: '#',
          },
        ],
      },
    ],
  },
  {
    title: 'Übersicht',
    id: 'detailSection',
  },
  {
    title: 'Downloads',
    url: [
      'productcode_downloads_35135.json',
      'approvaldownloads.json?title=S-20,S-20,S-20',
      'productdocumentsdownloads.json?title=S-20,S-20,S-20',
      'declarationsdownloads.json?title=S-20,S-20,S-20',
    ],
    isDownload: true,
    initialSelectOption: 'Bitte wählen...',
    selectAllOption: 'Alle',
    productTypes: ['732.14', '762.14'],
    labels: {
      pdf: 'PDF',
      ebook: 'E-Book',
      wishlist: 'Merkzettel',
      declarations: 'Herstellerinformationen und Bescheinigungen',
      projectdocuments: 'Projektdokumente',
      approvals: 'Zulassungen',
      certificationBody: 'Zulassungsstelle',
      typeOfApproval: 'Zulassungsart',
      economicArea: 'Land / Wirtschaftsraum',
    },
    mappingUrl: 'keyword_translation.json',
  },
  {
    tabID: 'standardarticle',
    title: 'Standardartikel',
    id: 'orderdata',
    url: ['standardartikel_tabelle_32932.WIKA'],
    // url: ['standardartikel_tabelle_8.WIKA'],
    isTable: true,
    hideTooltip: true,
    scrollWarning: 'Wischen Sie, um die Tabelle nach links und rechts zu scrollen.',
    detailLinkText: 'Details +++',
    RFQText: 'Anfragen',
    RFQUrl: 'iframe.html?globals=&args=&id=forms-rfq-form--rfq-form',
    productTypes: 'Typen 111.10, 111.12',
    shopLinkText: 'Zum Online-Shop',
    shopUrl: 'https://shop.wika.de/732_51_shop_de_de.WIKA?itemId=',
    showDatasheetLink: true,
    dataSheetLoadingText: 'wird generiert...',
    dataSheetText: 'Artikel-Datenblatt',
  },
  {
    tabID: 'configurator',
    title: 'Konfigurator',
    disabled: true,
  },
];
const cookieDisclaimerConfig = {
  text: 'Unsere Webseite verwendet Cookies. Durch die weitere Nutzung stimmen Sie der Verwendung zu.',
  link: {
    text: 'Weitere Informationen',
    url: '#',
  },
  button: {
    text: 'Zustimmen',
    colour: 'blue',
  },
};

const salesContainerConfig = {
  title: 'Vertriebs&shy;kontakt',
  icon: 'help',
  input: {
    placeholderText: 'Postleitzahl eingeben',
    submitUrl: 'contact_de_at.WIKA?cnType=1&cnEntry=',
  },
  buttons: [
    {
      icon: 'mail',
      offlineText: 'Online Shop',
      text: 'Online Shop',
    },
    {
      icon: 'draft',
      text: 'Kontaktformular',
      linkUrl: '#',
    },
  ],
};

const slides = [
  {
    image: 'https://i.ytimg.com/vi/WQ_lbJfiffs/mqdefault.jpg',
    video: 'https://www.youtube.com/embed/QbPEuTQvaiw?enablejsapi=1',
    text: 'Play-Taste mit Default Cursor und Modal-Overlay.',
    title: 'Eine Video slide',
    alt: 'Eine Video slide',
  },
  {
    image:
      'https://fastly.picsum.photos/id/404/312/312.jpg?hmac=rAfjYHppKQzEvZRRDO6R1UfvL6bgR-k6hLd-KMTh9xQ',
    video: '',
    text: 'Keine Play-Taste mit Zoom-In-Cursor und Modal-Overlay. Keine Play-Taste mit Zoom-In-Cursor und Modal-Overlay.',
    title: 'Eine Bild slide',
    alt: 'Eine Bild slide',
  },
  {
    image:
      'https://fastly.picsum.photos/id/566/160/160.jpg?hmac=b9LYjyTYsAkEi3Y6kRK5s0yETLMcfOmCfmt_oy2ndIo',
    video: '',
    text: 'Keine Play-Taste mit Zoom-In-Cursor und Modal-Overlay.',
    title: 'Noch eine Bild slide',
    alt: 'Noch eine Bild slide',
  },
];

const backBtnLabel = 'Zurück zur Übersicht';

const handleBackClick = () => {
  window.history.back();
};

onBeforeMount(() => {
  window.instance = 'website';
});
</script>

<style module lang="scss">
@forward './ProductDetailPage.scss';
</style>
